import { ComponentType } from '../table_component'
import { Schema } from '../types'

export const dbtimeSchema: Schema = {
  title: 'DB Time Breakdown',
  columns: [{ id: 'info', name: 'Info', component: ComponentType.Text }]
}

export const dbtimeBySQLTypeSchema: Schema = {
  title: 'Breakdown by SQL Type',
  level: 1,
  columns: [
    {
      id: 'sql_type',
      name: 'SQL Type',
      component: ComponentType.Text
    },
    {
      id: 'mean',
      name: 'Mean',
      component: ComponentType.MetricStats
    }
  ]
}

export const dbtimeBySQLPhaseSchema: Schema = {
  title: 'Breakdown by SQL Phase',
  level: 1,
  columns: [
    {
      id: 'sql_phase',
      name: 'SQL Phase',
      component: ComponentType.Text
    },
    {
      id: 'mean',
      name: 'Mean',
      component: ComponentType.MetricStats
    },
    {
      id: 'proportion',
      name: 'Proportion',
      component: ComponentType.MetricStats
    }
  ]
}

export const dbtimeByKVRequestSchema: Schema = {
  title: 'Breakdown by KV Request',
  level: 1,
  columns: [
    {
      id: 'request_type',
      name: 'KV Request Type',
      component: ComponentType.Text
    },
    {
      id: 'mean',
      name: 'Mean',
      component: ComponentType.MetricStats
    }
  ]
}
